<template>
    <svg class="home-page__svg" width="1440" height="743" viewBox="8640 0 1440 743" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8978 296H8735.5V244L8721.5 228H8638" stroke="#00A4FF" stroke-width="2"/>
        <path d="M9162 296H9466.5L9520 242.5H9586.5" stroke="#00A4FF" stroke-width="2"/>
        <circle cx="9032" cy="299.5" r="188" fill="#00A4FF" stroke="#00A4FF"/>
        <circle cx="9585" cy="242" r="5" fill="#5426E2"/>
    </svg>
</template>